import { Observable } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ElementService {
  /**
   * Creates an instance of element service.
   */
  constructor() { }

  /**
   * Intersections visible
   * @param element any
   * @returns Observable<any>
   */
  intersectionVisible(element: any, always: boolean = false): Observable<any> {
    return new Observable((subscriber) => {
      /**
       * El objeto intersectionObserverOptions pasado al constructor `IntersectionObserver()`
       * le deja controlar  las circunstancias bajo las cuales la función callback del
       * observer es invocada
       */
      const intersectionObserverOptions = {
        root: null,
        rootMargin: '150px',
        threshold: 1.0
      };
      /**
       * Declare class IntersectionObserver
       */
      const observer = new IntersectionObserver((entries: any) => {
        entries.forEach(entry => {
          /**
           * Are we in viewport?
           */
          if (entry.intersectionRatio === 1) {
            /**
             * subscriber
             */
            subscriber.next(entry.intersectionRatio);
            /**
             * Stop watching
             */
            if (!always) {
              observer.unobserve(element);
            }
          }
        });
      }, intersectionObserverOptions);

      /**
       * Una vez usted ha creado el observer, necesita darle un elemento target para observar:
       */
      observer.observe(element);
    });
  }
}
